import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridAngular } from 'ag-grid-angular';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ListComponent } from './list.component';
import { DirectivesModule } from '../../../../components/directives.module';

const ROUTES: Routes = [
  { path: '', component: ListComponent, pathMatch: 'full' },
];

@NgModule({
  declarations: [ListComponent],
  exports: [ListComponent],
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    RouterModule.forChild(ROUTES),
    AgGridAngular,
    MatAutocompleteModule,
    ReactiveFormsModule,
  ],
})
export class ListModule {}
